// components
import AppointmentForm from './AppointmentForm';

// hooks
import { useNarrowedShortcutContexts } from 'components/shared/ShortcutProvider/ShortcutProvider.hooks';

// stores
import { useAppointmentStore } from 'components/mrp/stores/appointmentStore/appointmentStore';
import { GLOBAL_CONTEXT } from 'components/shared/ShortcutProvider/ShortcutProvider.consts';
import { APPOINTMENT_FORM_CONTEXT } from './AppointmentForm.consts';

// utils
import { useShallow } from 'zustand/shallow';
import { Activity } from 'react';

const AppointmentFormVisibility = () => {
  const appointment = useAppointmentStore(
    useShallow((state) => state.appointment)
  );

  // The form's own context stays active alongside the global one, so its shortcuts keep
  // working and show up in the `shift+?` overview while the form is open. Everything else --
  // calendar navigation and interaction -- stays narrowed away.
  useNarrowedShortcutContexts(!!appointment, [
    GLOBAL_CONTEXT,
    APPOINTMENT_FORM_CONTEXT
  ]);

  return (
    <Activity mode={!!appointment ? 'visible' : 'hidden'}>
      <AppointmentForm key={appointment?.id} />
    </Activity>
  );
};

export default AppointmentFormVisibility;
